import { render, staticRenderFns } from "./ProfilePasswordChangeForm.vue?vue&type=template&id=468c4911&"
import script from "./ProfilePasswordChangeForm.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordChangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports